import gql from "graphql-tag";

export type ChallengeFragment = {
  id: string;
  sender: {
    id: string;
    name: string;
  };
  recipient: {
    id: string;
    name: string;
  };
  sentAt: string;
  rematchOf: {
    id: string;
  };
  status: string;
  game: {
    id: string;
  };
  senderColor: string;
  senderArmy: string;
  recipientArmy: string;
};

export const challengeFragment = gql`
  fragment Challenge on Challenge {
    id
    sender {
      id
      name
    }
    recipient {
      id
      name
    }
    sentAt
    rematchOf {
      id
    }
    status
    game {
      id
    }
    senderColor
    senderArmy
    recipientArmy
  }
`;

export type ChallengeQuery = {
  me?: {
    id: string;
  };
  challenge?: ChallengeFragment;
};

export const challengeQuery = gql`
  query challengeQuery($id: ID!) {
    me {
      id
    }

    challenge(id: $id) {
      ...Challenge
    }
  }

  ${challengeFragment}
`;

export const challengeSend = gql`
  mutation challengeSend(
    $recipientId: ID!
    $rematchOfId: ID
    $senderArmy: ChallengeArmy!
    $senderColor: ChallengeColor
  ) {
    challengeSend(
      recipientId: $recipientId
      rematchOfId: $rematchOfId
      senderArmy: $senderArmy
      senderColor: $senderColor
    ) {
      ...Challenge
    }
  }

  ${challengeFragment}
`;

export const challengeWithdraw = gql`
  mutation challengeWithdraw($id: ID!) {
    challengeWithdraw(id: $id) {
      ...Challenge
    }
  }

  ${challengeFragment}
`;

export const challengeAccept = gql`
  mutation challengeAccept(
    $id: ID!
    $recipientArmy: ChallengeArmy!
    $recipientColor: ChallengeColor!
  ) {
    challengeAccept(
      id: $id
      recipientArmy: $recipientArmy
      recipientColor: $recipientColor
    ) {
      ...Challenge

      game {
        white {
          id
        }
      }
    }
  }

  ${challengeFragment}
`;

export const challengeReject = gql`
  mutation challengeReject($id: ID!) {
    challengeReject(id: $id) {
      ...Challenge
    }
  }

  ${challengeFragment}
`;
